import React from 'react';
import DSIcon from './DSIcon';

const SearchBar = ({ label, value = '', placeholder, onValueChange, action, classes = '' }) => {
  return (
    <div className={classes}>
      <h1 className='mb-2 text-2xs font-semibold uppercase tracking-[0.08em] text-gray-600'>{label}</h1>
      <div className='relative flex items-center'>
        <button
          type='button'
          aria-label='Search'
          onClick={() => action && value.trim() && action(value)}
          className='absolute right-2 inline-flex h-9 w-9 items-center justify-center rounded-ds-md text-gray-500 transition-colors duration-150 hover:bg-gray-100 hover:text-gray-900'
        >
          <DSIcon name='search' size={16} />
        </button>
        <input
          type='text'
          name='input-search'
          value={value}
          placeholder={placeholder}
          onChange={(event) => onValueChange(event.target.value)}
          className='h-11 w-full rounded-ds-sm border border-gray-275 bg-white px-3 pr-12 text-xs font-medium text-gray-900 placeholder-gray-400 transition-shadow duration-150 focus:border-gray-900 focus:outline-none focus:ring-1 focus:ring-gray-900'
        />
      </div>
    </div>
  );
};

export default SearchBar;
